/**
 * Returns a double in the interval [0, 1) using JavaScript Math.random().
 * @return {number}
 */
const random = () => {
	return Math.random();
};

export default random;
